export const perspectiveData = [
  {
    id: 1,
    img: "",
    name: "Ayush Gupta",
    position: "",
    paraOne:
      "As a young professional managing multiple credit card debts, I was overwhelmed by the high-interest rates and the complexity of keeping track of various payments. Discovering Minemi’s balance transfer calculator was a game-changer. It provided a clear comparison of my current debt situation against potential savings through balance transfers. By consolidating my debts into a single, lower-interest loan, I significantly reduced my monthly payments and overall interest burden. The user-friendly interface and insightful tips empowered me to make informed financial decisions. Thanks to Minemi, I’m now on a structured path to becoming debt-free, and I feel more in control of my finances than ever before.",
  },
  {
    id: 1,
    img: "",
    name: "Nitin Sharma",
    position: "",
    paraOne:
      "After years of juggling high-interest credit card balances, I felt trapped in a cycle of debt with no clear way out. Minemi’s balance transfer calculator offered a lifeline. It allowed me to input my debt details and explore various balance transfer options tailored to my situation. The detailed breakdown of potential savings and repayment timelines was eye-opening. By following the recommendations, I transferred my balances to a lower-interest card and set up fixed EMIs, making my debt more manageable. The process was straightforward, and the guidance provided was invaluable. Minemi has not only helped me save money but also restored my confidence in achieving financial stability",
  },
];

export const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
